(($, Drupal) => {
    Drupal.behaviors.mainBanner = {
        attach: function attach() {
            $(".main-banner__wrapper").once("main-banner").each(function() {
                
                $(this).find("." + sliderClasses.dotsClass).addClass('main-banner__dots');
                $(this).data('owl.carousel').options.dots = true;
                $(this).trigger('refresh.owl.carousel');
            });
        }
    };

})(jQuery, Drupal);
  